import styled, { css } from 'styled-components'

import { TextInput } from 'reactGarden/Input'

import { MainTitle } from '../common/Title'

export const Text = styled.p`
  text-align: left;
`

export const Title = styled.h1(
  ({ theme }) => `
    color: ${theme.colors.n600};
    font-size: 16px;
    font-weight: ${theme.font.weight.semibold};
    margin-bottom: 20px;
  `
)

export const WrapperButton = styled.div`
  display: flex;
  justify-content: center;
`

export const Wrapper = styled.section(
  ({ theme }) => `
    text-align: center;
    background: ${theme.colors.white};
    padding: 15px 5px;
    margin-top: 15px;

    @media (min-width: ${theme.media.tablet}) {
      padding: 20px;
    }
  `
)

export const Header = styled.header`
  margin-bottom: 30px;
`

export const HeaderWrapper = styled.section(
  ({ theme }) => `
    background: ${theme.colors.white};
    display: flex;
    padding: 15px 10px;
    align-items: flex-start;
    justify-content: space-between;
    flex-direction: column;
    margin-top: 15px;

    @media (min-width: ${theme.media.tablet}) {
      flex-direction: row;
    }

    @media (min-width: ${theme.media.laptop.sm}) {
      padding: 15px;
    }
  `
)

export const HeaderTitle = styled(MainTitle)(
  ({ theme }) => `
    margin: 0 0 15px 0;

    @media (min-width: ${theme.media.tablet}) {
      line-height: 1.1875;
      margin: 0;
    }
  `
)

export const Subtitle = styled.p(
  ({ theme }) => `
    color: ${theme.colors.n400};
    font-size: 14px;
    line-height: 1.5;
    margin: 0;
  `
)

export const PostalCodeSubtitle = styled.p(
  ({ theme }) => `
    color: ${theme.colors.n400};
    font-size: 14px;
    line-height: 1.5;
    margin: 0;
  `
)

export const PostalCodeWrapper = styled.section(
  ({ theme }) => `
    align-items: center;
    background: ${theme.colors.white};
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-top: 15px;
    order: 1;
    padding: 15px 10px;

    @media (min-width: ${theme.media.tablet}) {
      flex-direction: row;
      order: 0;
    }

    @media (min-width: ${theme.media.laptop.sm}) {
      padding: 15px;
    }
  `
)

export const Info = styled.div`
  margin-right: 15px;
  margin-bottom: 5px;
`

export const PostalCodeFieldset = styled.div(
  ({ theme }) => `
    display: flex;
    flex-direction: column;
    margin-top: 12px;
    position: relative;
    width: 100%;

    @media (min-width: ${theme.media.tablet}) {
      margin-top: 0;
      max-width: 270px;
    }

    svg {
      position: absolute;
      top: 35px;
      right: 12px;
    }
  `
)

export const PostalCodeInput = styled(TextInput)(
  ({ theme, statusZipCode }) => `
    border-color: ${statusZipCode ? theme.colors[statusZipCode] : theme.colors.n100};
    padding: 8px 15px;
  `
)

export const baseTextStyle = css`
  font-size: 12px;
  margin-left: 16px;
`

export const PostalCodeLabel = styled.label(
  ({ theme }) => `
    ${baseTextStyle}
    color: ${theme.colors.n800};
    font-weight: ${theme.font.weight.semibold};
  `
)

export const PostalCodeLink = styled.a`
  ${baseTextStyle}
`

export const DeadlineBox = styled.div(
  ({ theme }) => `
    background-color: ${theme.colors.n100};
    font-size: 13px;
    margin-bottom: 1px;
    padding: 7px 13px;
    width: 100%;

    &:last-child {
      margin-bottom: 10px;
    }
  `
)

export const BoldText = styled.span(
  ({ theme }) => `
    font-weight: ${theme.font.weight.semibold};
  `
)

export const SummaryWrapper = styled.section(
  ({ theme, props }) => `
    margin: ${props => (props.context === 'scanAndGo' ? '0' : '15px 0')};

    .bold {
      font-weight: bold;
    }

    @media (min-width: ${theme.media.laptop.sm}) {
      margin: 15px 0 0 50px;
      position: sticky;
      top: 5px;
    }
  `
)

export const CartInfo = styled.div(
  ({ theme, context }) => `
    background: ${theme.colors.white};
    border-top: ${context === 'scanAndGo' ? '1px' : '0'} solid ${theme.colors.n100};
  `
)

export const CartItem = styled.div(
  ({ theme }) => `
    align-items: center;
    border-bottom: 1px solid ${theme.colors.n100};
    display: flex;
    justify-content: space-between;
    padding: 20px 10px;

    @media (min-width: ${theme.media.laptop.sm}) {
      padding: 20px 15px;
    }
  `
)

export const Footer = styled.footer(
  ({ theme }) => `
    align-items: center;
    display: flex;
    font-size: 18px;
    justify-content: space-between;
    padding: 20px 10px;

    @media (min-width: ${theme.media.laptop.sm}) {
      padding: 20px 15px;
    }
  `
)

export const DiscountInputWrapper = styled.div(
  ({ theme }) => `
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    & span {
      color: ${theme.colors.p500};
      font-weight: bold;
      margin-top: 5px;
    }
  `
)

export const canBePurchased = ({ canBePurchased, theme }) =>
  !canBePurchased &&
  css`
    background: ${theme.colors.n300};
    pointer-events: none;
  `

export const ButtonWrapper = styled.div`
  margin-top: 24px;
`
